import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import QuizHomeSection from '../components/quiz_section/QuizHomeSection';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
  } from "react-device-detect";
  

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        exams{
            id
            exam
            exam_subjects{
                subject_id
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
        complexity{
            id
            complexity
            
        }
    }
}

`;

const FETCH_SECTIONS = gql` 
query($institution_id: Int!) {
    getSections(institution_id: $institution_id){
        id
        section_name
        branch_id
    }
}

`;

const FETCH_RESULTS = gql`
  query($institution_id: Int!) {
    getQuizCompletedExams(institution_id: $institution_id){
        id
        exam_name
        class_id
        section
        }
    }
`;


const FETCH_SAVED_PAPERS = gql`
  query($institution_id: Int!) {
    getSavedQuizPapers(institution_id: $institution_id) {
        id
        name
        exam_type
        no_of_sets
        start_time
        end_time
        time_duration
        is_completed
        class
        section
        branch
        type
        class_id
        exam_model_id
        is_partexam
        mains_2021
        timestamp
        estatus
        sub_exam_type
        total_question_count
        exam_questions{
            id
            subject
            chapter
            topic
            question
            qtype
            option1
            option2
            option3
            option4
            chapter_name
            topic_name
            complexity
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
        }
    }
  }
`;

const FETCH_SCHEDULED_PAPERS = gql`
  query($institution_id: Int!) {
    getScheduledQuiz(institution_id: $institution_id) {
        schedulequiz{
            id
            exam_name
            exam_type
            section
            branch
            type
            class_id
            is_completed
            time_duration
            exam_model_type_id
            start_time
            end_time
            publish
            estatus
            timestamp
            institution_id
            is_draft
            total_students
            students
            started
            submitted_students
            not_started
            exam_questions{
                id
                subject
                chapter
                topic
                question
                qtype
                option1
                option2
                option3
                option4
                chapter_name
                topic_name
                complexity
                compquestion
                list1type
                list2type
                mat_question
                answer
                inputquestion
            }
            
        }
        livequiz{
            id
            exam_name
            exam_type
            section
            branch
            type
            class_id
            is_completed
            time_duration
            exam_model_type_id
            start_time
            end_time
            publish
            estatus
            timestamp
            institution_id
            is_draft
            total_students
            students
            started
            submitted_students
            not_started
            exam_questions{
                id
                subject
                chapter
                topic
                question
                qtype
                option1
                option2
                option3
                option4
                chapter_name
                topic_name
                complexity
                compquestion
                list1type
                list2type
                mat_question
                answer
                inputquestion
            }
        }
    }
  }
`;

class Quiz extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getSections = this.props.getSections;
        const loading2 = getSections.loading;
        const error2 = getSections.error;

        const getQuizCompletedExams = this.props.getQuizCompletedExams;
        const loading3 = getQuizCompletedExams.loading;
        const error3 = getQuizCompletedExams.error;


        const savedPapers = this.props.getSavedQuizPapers;
        const loading4 = savedPapers.loading;
        const error4 = savedPapers.error;

        const scheduledQuiz = this.props.getScheduledQuiz;
        const loading5 = scheduledQuiz.loading;
        const error5 = scheduledQuiz.error;


        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }
        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <Preloader />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                        {
                            loading1 || loading4 ?
                                (
                                    <Container><Row className="my-3">
                                        <Col>
                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>
                                    </Row></Container>
                                )
                                :
                                (
                                    <QuizHomeSection
                                        globals={globals.globals}
                                        getSections={getSections.getSections}
                                        getQuizCompletedExams={getQuizCompletedExams.getQuizCompletedExams}
                                        savedPapers={savedPapers.getSavedQuizPapers}
                                        scheduledQuiz={scheduledQuiz.getScheduledQuiz}
                                    />

                                )
                        }
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}




export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "globals"
            }),
        graphql(FETCH_SECTIONS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "getSections"
            }),
        graphql(FETCH_RESULTS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid")),
                        exam_paper_id: 0
                    }
                    ,
                    fetchPolicy: 'network-only'
                }), name: "getQuizCompletedExams"
            }),
        graphql(FETCH_SAVED_PAPERS, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only',
            }),
            name: "getSavedQuizPapers"
        }),
        graphql(FETCH_SCHEDULED_PAPERS, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only',
            }),
            name: "getScheduledQuiz"
        })
    )
        (Quiz));